<ion-content [fullscreen]="true" class="mapkit-container">
 
  <div id="mapkitMapId" class="mapkit-map"></div>
  <div class="mapkit-marker" [class.dragging]="isDragging">
    <span class="mapkit-marker__icon"></span>
  </div>
  <div *ngIf="!isInitialized" class="mapkit-loading">
  </div>
</ion-content>

